import PaymentComplete from "../FeedBack/PaymentComplete";

const PayedViaLinkContainer = () => {
    return (
        <PaymentComplete />
    );
};

export default PayedViaLinkContainer;